// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"Modal_modal-container__3xOKu","modal-content":"Modal_modal-content__1XgYc","close-btn":"Modal_close-btn__2TO1J"};